import  { useEffect, useState } from "react";
import {
  Box,
  Stack,
  IconButton,
  Tooltip,
  Badge,
} from "@mui/material";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import PercentRoundedIcon from "@mui/icons-material/PercentRounded";
import ActivityModal from "./Activity";
import { QuickSale_PAP_ACTIVITY_GETROW } from "../../../Server/ApiV2";
import { fAlertToast } from "../../../Utility/Utilitys";


const SideNavToolbar = ({
  transId,
  userCd,
  selectedRow,
  pageType,
  loadSummary
}) => {

  const [activities, setActivities] = useState([]);
  const [showActivity, setShowActivity] = useState(false);

  const handleActivityClick = () => setShowActivity((s) => !s);

    const fetchActivities = async () => {
      try {
        if (transId) {
          const res = await QuickSale_PAP_ACTIVITY_GETROW({
            TransId: transId || "",
          });
          if (res.status === 200) setActivities(res?.data?.recordset ?? []);
        }
      } catch (err) {
        fAlertToast("FAILED", err?.response?.data?.message || err?.message);
      }
    };

  useEffect(() => {
      fetchActivities();
    }, []);




     // 🔵 COLOR BASED ON PERCENT
  const getColor = (p) => {
    if (p <= 20) return "#2196f3"; // Blue
    if (p <= 40) return "#9c27b0"; // Purple
    if (p <= 60) return "#ff9800"; // Orange
    if (p <= 80) return "#ffc107"; // Yellow
    return "#4caf50"; // Green
  };

  const percent = Number(selectedRow?.CompletionPerc) || 0;
  const radius = 18;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percent / 100) * circumference;
  const color = getColor(percent);


  return (
    <>
      {/* Toolbar row */}
      <Stack
        direction="row"
        spacing={1}
        mt={0.5}
        alignItems="center"
        justifyContent={"flex-end"}
      >
        {selectedRow?.PDF_URL && (
          <Tooltip title="Export as PDF">
            <IconButton
              size="small"
              sx={{ color: "#ff5252" }}
              onClick={() => {
                const pdfUrl = selectedRow.PDF_URL;
                const link = document.createElement("a");
                link.href = pdfUrl;
                link.target = "_blank"; // opens in new tab
                link.download = pdfUrl.split("/").pop() || "file.pdf"; // triggers download
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              <PictureAsPdfRoundedIcon />
            </IconButton>
          </Tooltip>
        )}
<Tooltip title={showActivity ? "Hide Activity" : "Show Activity"}>
  <IconButton
    size="small"
    sx={{ color: "#5b8def", position: "relative" }}
    onClick={handleActivityClick}
  >
    <Badge
      badgeContent={activities?.length}
      color="warning"
      max={99}
      invisible={activities?.length == 0}
      sx={{
        "& .MuiBadge-badge": {
          display: activities?.length === 0 ? "none" : "flex",   // 👈 Force hide
          minWidth: 16,
          height: 16,
          fontSize: "0.65rem",
          lineHeight: "16px",
          border: "1.5px solid #fff",
          padding: "0 4px",

          // Responsive badge positioning
          position: "absolute",
          top: {
            xs: "-12px",   // small screens
            sm: "-6px",   // medium
          },
          right: {
            xs: "-8px",   // small screens
            sm: "-6px",   // medium/large
          },
          transform: "none !important",
        },
      }}
    >
      <HistoryRoundedIcon sx={{ fontSize: 22 }} />
    </Badge>
  </IconButton>
</Tooltip>

        {/* <Tooltip title="Show Status">
          <IconButton size="small" sx={{ color: "#4caf50" }}>
            {selectedRow?.CompletionPerc} <PercentRoundedIcon />
          </IconButton>
        </Tooltip> */}



         {/* 🔵 REPLACED YOUR OLD PERCENTAGE BUTTON WITH DONUT */}
        <Tooltip title="Show Status">
  <IconButton size="small" sx={{ p: 0.2 }}>
    <Box sx={{ width: 35, height: 35, position: "relative" }}>
      <svg width="35" height="35">
        {/* Background ring */}
        <circle
          cx="17.5"
          cy="17.5"
          r={13}           // smaller radius
          stroke="#e0e0e0"
          strokeWidth="7"
          fill="none"
        />

        {/* Percentage ring */}
        <circle
          cx="17.5"
          cy="17.5"
          r={13}
          stroke={color}
          strokeWidth="7"
          fill="none"
          strokeDasharray={2 * Math.PI * 14}
          strokeDashoffset={2 * Math.PI * 14 - (percent / 100) * (2 * Math.PI * 14)}
          strokeLinecap="round"
          style={{ transition: "0.3s ease" }}
        />
      </svg>

      {/* Center text */}
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "9px",
        fontWeight: 900

        }}
      >
        {percent}%
      </Box>
    </Box>
  </IconButton>
</Tooltip>

      </Stack>
      {
        <ActivityModal
          userCd={userCd}
          open={showActivity}
          onClose={handleActivityClick}
          transId={transId}
          loadSummary={loadSummary}
          activities={activities}
          fetchActivities={fetchActivities}
        />
      }
    </>
  );
};

export default SideNavToolbar;
